import { ChevronRight24 } from 'ui/icons';
import { SvgLogoProps } from 'ui/thirdPartyLogos/SvgLogo';
import { colors } from 'ui/theme';
import { LOGO_LENGTH, SendingPlatform } from '../../constants';
import { useMetadata } from '../../hooks';
import { sendingPlatformDetailsPath } from '../../utils';
import {
  Wrapper,
  LogoContainer,
  ArrowContainer,
  Name,
  Title,
  CategoryTag,
  Description,
} from './PlatformDescriptionCard.styled';

export type PlatformDescriptionCardProps = {
  sendingPlatform: SendingPlatform;
};

export const PlatformDescriptionCard = ({ sendingPlatform }: PlatformDescriptionCardProps) => {
  const { name, category, indexDescription, logoSvg } = useMetadata(sendingPlatform);
  const Logo = logoSvg as React.FC<React.PropsWithChildren<SvgLogoProps>>;
  const linkTo = sendingPlatformDetailsPath(sendingPlatform);

  return (
    <Wrapper to={linkTo}>
      <LogoContainer>
        <Logo height={LOGO_LENGTH} width={LOGO_LENGTH} />
      </LogoContainer>
      <Title>
        <Name>{name}</Name>
        {category && <CategoryTag>{category}</CategoryTag>}
      </Title>
      <Description>{indexDescription}</Description>
      <ArrowContainer>
        <ChevronRight24 color={colors.secondaryText} />
      </ArrowContainer>
    </Wrapper>
  );
};
